export const HEADING = {
    H1: 'H1',
    H2: 'H2',
    H3: 'H3',
    H4: 'H4'
}
